module.exports = __webpack_public_path__ + "static/media/Gotham-Book.b2df2432.ttf";